import Preference, { type PreferenceValue } from './Preference';

type Storage = typeof localStorage;

type StoredPreferences = {
  [preferenceId: string]: PreferenceValue
};

export default class PreferenceStorage {
  private storage: Storage;

  private storageKey: string;

  private namespace: string = '';

  constructor(storage: Storage, storageKey: string) {
    this.storage = storage;
    this.storageKey = storageKey;
  }

  load(): StoredPreferences {
    const data = this.storage.getItem([this.namespace, this.storageKey].join('.'));

    return data === null ? {} : (JSON.parse(data) as StoredPreferences);
  }

  addNamespace(namespace: string): void {
    this.namespace = namespace;
  }

  persist(preference: Preference): void {
    const data = this.load();

    data[preference.id] = preference.toRawObject();

    this.storage.setItem([this.namespace, this.storageKey].join('.'), JSON.stringify(data));
  }
}
